exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-us h2 {\r\n  text-align: center;\r\n}\r\n\r\n.about-us img {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.about {\r\n  background-color: #67766a;\r\n  color: #f1f1f1;\r\n  height: auto;\r\n}\r\n\r\n.team h2 span {\r\n  background-color: #85baac;\r\n  color: #f1f1f1;\r\n  font-weight: 600;\r\n}\r\n\r\n.team p, .story p, .influence p {\r\n  color: #4b525b;\r\n}\r\n\r\n.team .img-width {\r\n  width: 75%;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .team .img-width {\r\n    width: 50%;\r\n  }\r\n}\r\n\r\n.story h2, .influence h2 {\r\n  color: #85baac;\r\n}\r\n\r\n.story, .influence {\r\n  background-color: #edf5f3;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/about/about-us/about-us.component.css
// module id = ../../../../../src/app/components/about/about-us/about-us.component.css
// module chunks = main